<script>
    import { onMount } from 'svelte';
    import ForceGraph from './ForceGraph.svelte';
    import { getParams } from './utils.js';
    import { Circle3 } from 'svelte-loading-spinners';

    const params = getParams();

    let keyword = params.keyword;
    let date = params.date;

    let data;
    let error;

    async function loadGraph(){
        const url = 'https://55c9cm45v3.execute-api.us-east-1.amazonaws.com/api/tweets/' + keyword + '?date=' + date ;
        try {
            const result = await fetch(url);
            if (!result.ok) {
                throw new Error(result.statusText);
            }
            const response = await result.json();
            data = response['data']['graph'];
        } catch (err) {
            error = err;
            console.log(error);
        }
    }
    onMount(() => {
        loadGraph();  // add parameters as required
    }); 
</script>

<div class="graph-container flex-grow border-zinc-700 rounded-l-2xl border-2 p-10 bg-zinc-800">        
    {#if data}
        <ForceGraph 
            {data} 
            nodeId={d => d.id}
            nodeGroup={d => d.group}
            nodeTitle={d => `${d.id}`}
            width={window.innerWidth}
            height={window.innerHeight}
        />
    {:else if error}
        <div class="flex justify-center items-center h-full">
            <p class="bg-red rounded text-white p-4 font-bold opacity-50">ERROR: {error.message}</p>
        </div>
    {:else}
        <div class="flex justify-center items-center h-full">
            <Circle3 size="200" unit="px" duration="1s"  />
        </div>
    {/if}
</div>
